import type { Theme } from '@mui/material/styles';
import type { FieldErrors } from 'react-hook-form';
import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    errors?: FieldErrors;
  }>()
  .create(({ theme, errors }: { theme: Theme; errors?: FieldErrors }) => ({
    ticketCreateDialogFormElement: {
      width: '100%'
    },
    ticketCreateDialogIconButtonCancel: {
      height: '2rem',
      position: 'absolute',
      right: 8,
      top: 8,
      width: '2rem'
    },
    ticketCreateDialogMultilineInput: {
      padding: '0.8rem 1rem'
    },
    summaryErrorBorder: {
      borderColor: errors?.summary
        ? theme.vars.palette.error.main
        : `rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)`,
      borderRadius: '4px',
      borderStyle: 'solid',
      borderWidth: '1px'
    }
  }));

export default useStyles;
